import React from 'react';
import { Box, Typography, Grid, Card, CardContent, Chip, Button } from '@mui/material';
import { Image } from 'mui-image';
import networkimage from '../Assets/network-architecture.png'

const projectPosts = [
  {
    title: "Enterprise Network Deployment Prototype",
    category: "Architecture",
    date: "June 2026",
    excerpt: "End-to-end network architecture featuring VLAN segmentation, ACLs, and SQL logging.",
    img: networkimage,
    color: "#00ffff",
    link: "/projects/network-architecture"
  },
  {
    title: "Jumia E-Commerce: QA Test Report",
    category: "Quality Assurance",
    date: "June 2026",
    excerpt: "Comprehensive QA analysis of Jumia's search, cart persistence, and performance logic.",
    img: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=1080",
    color: "#ff0033",
    link: "/projects/jumia-qa"
  },
  {
    title: "Discovering a 0-Day in Popular CMS",
    category: "Security Research",
    date: "Dec 15, 2024",
    excerpt: "Deep dive into the process of responsibly disclosing a critical vulnerability.",
    img: "https://images.unsplash.com/photo-1760670399462-f5e479452c27?q=80&w=1080",
    color: "#ff0033",
    link: "/projects/security-research"
  }
];

const Blog = () => {
  return (
    <Box maxWidth="lg" component="section" id="blog" sx={{ py: 10, mx: 'auto', px: 2 }}>
      <Typography variant="h2" sx={{ textAlign: "center", mb: 2, color: "primary.main" }}>
        <span style={{ color: "#00ffff" }}>$</span> tail -f blog.log
      </Typography>
      <Grid container spacing={4} sx={{ mt: 2 }}>
        {projectPosts.map((post, index) => (
          <Grid item xs={12} md={4} key={index}>
            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', bgcolor: "background.paper" }}>
              <Image src={post.img} alt={post.title} style={{ width: "100%", height: "200px" }} />
              <CardContent sx={{ flexGrow: 1 }}>
                <Chip label={post.category} size="small" sx={{ bgcolor: post.color, mb: 2 }} />
                <Typography variant="h6">{post.title}</Typography>
                <Typography variant="body2" sx={{ color: "text.secondary", mt: 1 }}>{post.excerpt}</Typography>
              </CardContent>
              <Box sx={{ p: 2 }}>
                <Button variant="outlined" fullWidth href={post.link} sx={{ borderColor: post.color, color: post.color }}>
                  View Analysis →
                </Button>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
export default Blog;